import React, { useState } from "react";
import InputField from "./InputField";
import ResultDisplay from "./ResultDisplay";

// Mock weights for demonstration purposes
const weights = {
  
  newsPresent: {
    "High Impact (RED)": 2,
    "Medium Impact (YELLOW)": 5,
    "Low Impact (GREEN)": 7,
    "None": 9,
  },
  timeFrame: {
    "1 min": 1,
    "5 mins": 2,
    "15 mins": 3,
    "30 mins": 5,
    "1 hr": 6,
    "2 hrs": 8,
    "4 hrs": 9,
  },
  strategy: {
    "Cup and Handle": 5,
    "Inverted Cup & Handle": 5,
    "Double Top": 8,
    "Double Bottom": 8,
    "None": 0,
  },
  confluences: { "> or = 3": 10, "2": 6, "1": 3, "None": 0 },
  riskRatio: { "3:1": 2, "2:1": 2, "1:1": 2, "1:2": 2, "1:3": 2, "None": 0 },
  lotSize: {
    "1:1": 2,
    "1:10": 2,
    "1:100": 2,
    "1:1000": 2,
    "1:10000": 2,
    "1:100000": 2,
    "None": 0,
  },
  alertPut: { "Yes": 7, "No": 3 },
  exitPlan: {
    "After an alert trigger.": 8,
    "Take Profit hit": 8,
    "Stop Loss hit": 0,
    "None": 0,
  },
  
  // Add more for the remaining 9
};

const defaultValues = {
  newsPresent: "",
  timeFrame: "",
  strategy: "",
  confluences: "",
  riskRatio: "",
  lotSize: "",
  alertPut: "",
  exitPlan: "",
  // Add all 12 inputs here
};

const TradeInputForm = () => {
  const [inputs, setInputs] = useState(defaultValues);
  const [result, setResult] = useState(null);

  const handleChange = (name, value) => {
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const calculateWinRate = () => {
    let total = 0;
    let maxTotal = 0;

    for (let key in inputs) {
      const val = inputs[key];
      const weightMap = weights[key];
      if (weightMap && val in weightMap) {
        total += weightMap[val];
        maxTotal += Math.max(...Object.values(weightMap));
      }
    }

    const percentage = ((total / maxTotal) * 100).toFixed(2);
    setResult(percentage);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    calculateWinRate();
  };

  return (
    <div className="p-6 bg-sky-900 shadow-md rounded-xl max-w-3xl mx-auto mt-10">
      <h2 className="text-3xl font-bold mb-4 text-center text-sky-100">
        Forex Trade Analyzer
      </h2>
      <hr className="w-[85%] h-4 mx-auto"/>
      <form onSubmit={handleSubmit} className="space-y-4">
        <InputField
          label="News Present Today From Forex Factory?"
          name="newsPresent"
          options={Object.keys(weights.newsPresent)}
          value={inputs.trend}
          onChange={handleChange}
        />
        <InputField
          label="Time Frame"
          name="timeFrame"
          options={Object.keys(weights.timeFrame)}
          value={inputs.trend}
          onChange={handleChange}
        />
        <InputField
          label="Strategy Applied"
          name="strategy"
          options={Object.keys(weights.strategy)}
          value={inputs.volume}
          onChange={handleChange}
        />
        <InputField
          label="Confluences"
          name="confluences"
          options={Object.keys(weights.confluences)}
          value={inputs.pattern}
          onChange={handleChange}
        />
        <InputField
          label="Risk Ratio"
          name="riskRatio"
          options={Object.keys(weights.riskRatio)}
          value={inputs.pattern}
          onChange={handleChange}
        />
        <InputField
          label="Lot Size"
          name="lotSize"
          options={Object.keys(weights.lotSize)}
          value={inputs.pattern}
          onChange={handleChange}
        />
        <InputField
          label="Any Alert Put?"
          name="alertPut"
          options={Object.keys(weights.alertPut)}
          value={inputs.pattern}
          onChange={handleChange}
        />
        <InputField
          label="Exit Plan"
          name="exitPlan"
          options={Object.keys(weights.exitPlan)}
          value={inputs.pattern}
          onChange={handleChange}
        />
        
        {/* Add 9 more <InputField /> components similarly */}
        {result && <ResultDisplay percentage={result} />}

        <button
          type="submit"
          className="w-full py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
        >
          Analyze Trade
        </button>
      </form>

      {/* {result && <ResultDisplay percentage={result} />} */}
    </div>
  );
};

export default TradeInputForm;
